module.exports = global["jQuery"] = require("-!/builds/A-Team/gabor/node_modules/expose-loader/index.js?$!./jquery.js");